export default __webpack_public_path__ + "static/media/contacttheartistscandeliertitle.e81caf8b.png";